import { useEffect } from "react";
import { toast } from "sonner";
import { BACKEND_URL, api, setToken } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const LABEL = { subscription: "subscribed to you", tip: "sent you a tip", unlock: "unlocked your paid message" };

export default function RealtimeBridge() {
  const { user } = useAuth();
  const uid = user?.id;

  useEffect(() => {
    if (!uid) return;
    let ws;
    let timer;
    let retry = 0;
    let closed = false;
    const connect = () => {
      const token = localStorage.getItem("velvet_token") || "";
      ws = new WebSocket(`${BACKEND_URL.replace(/^http/, "ws")}/api/ws?token=${encodeURIComponent(token)}`);
      ws.onopen = () => { retry = 0; };
      ws.onmessage = (e) => {
        const data = JSON.parse(e.data);
        window.dispatchEvent(new CustomEvent("riff:ws", { detail: data }));
        if (data.type === "message" || data.type === "message_unlocked") window.dispatchEvent(new Event("riff:messages-updated"));
        if (data.type === "notification") {
          window.dispatchEvent(new Event("riff:notifications-updated"));
          const n = data.notification;
          toast.success(`@${n.actor?.username || "someone"} ${LABEL[n.type] || n.text}${n.amount ? ` · $${n.amount.toFixed(2)}` : ""}`);
        }
      };
      ws.onclose = async (e) => {
        if (closed) return;
        if (e.code === 4401) {
          try { setToken((await api.post("/auth/refresh")).data.access_token); } catch { /* logged out */ }
        }
        timer = setTimeout(connect, Math.min(30000, 1000 * 2 ** retry++));
      };
    };
    connect();
    const ping = setInterval(() => ws?.readyState === 1 && ws.send("ping"), 25000);
    return () => { closed = true; clearTimeout(timer); clearInterval(ping); ws?.close(); };
  }, [uid]);

  return null;
}
